import { CustomCellRendererProps } from '@ag-grid-community/react';
import React from 'react';
import ReactHtmlParser from 'react-html-parser'; 

export default (params: CustomCellRendererProps) => {
    return (
        <div className='projectHistory'> {ReactHtmlParser(params.value)} </div>
    );
};
